export default "__VITE_ASSET__hk$ic3$q__"